import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Scrolls the window to the top whenever the route changes.
 * Mount inside <Router> so it can access the current location.
 */
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}